import loadable from '@loadable/component';
import { useMediaQuery } from '@mui/material';

import theme from 'features/core/theme';
import { FooterSection } from './FooterSection';

export default function Footer() {
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const DesktopFooter = isMd ? (
    loadable(() => import('./DesktopFooter'))
  ) : (
    <></>
  );
  const BottomFooter = loadable(() => import('./BottomFooter'));
  const MobileFooter = !isMd ? loadable(() => import('./MobileFooter')) : <></>;

  return (
    <FooterSection>
      {isMd ? <DesktopFooter /> : <MobileFooter />}
      <BottomFooter />
    </FooterSection>
  );
}
